/**
 * Fix drawer positioning by moving it to body level
 * This ensures the drawer appears on top of all content
 */
(function() {
  function moveDrawerToBody() {
    const drawer = document.querySelector('#NavDrawer');
    if (drawer && drawer.parentElement.tagName !== 'BODY') {
      document.body.appendChild(drawer);
    }
  }

  function initializeVideoSections() {
    const videoSections = document.querySelectorAll('[data-section-type="video-section"]');

    videoSections.forEach(function(section) {
      const youtubeDiv = section.querySelector('[data-type="youtube"]');
      const vimeoDiv = section.querySelector('[data-type="vimeo"]');

      if (youtubeDiv && window.theme && window.theme.YouTube) {
        const videoId = youtubeDiv.getAttribute('data-video-id');
        const elementId = youtubeDiv.id;

        if (videoId && elementId) {
          try {
            new window.theme.YouTube(elementId, {
              videoId: videoId,
              type: 'youtube'
            });
          } catch (e) {
            console.error('Error initializing YouTube video:', e);
          }
        }
      }

      if (vimeoDiv && window.theme && window.theme.VimeoPlayer) {
        const videoId = vimeoDiv.getAttribute('data-video-id');
        const elementId = vimeoDiv.id;

        if (videoId && elementId) {
          try {
            new window.theme.VimeoPlayer(elementId, {
              videoId: videoId,
              type: 'vimeo'
            });
          } catch (e) {
            console.error('Error initializing Vimeo video:', e);
          }
        }
      }
    });
  }

  function init() {
    moveDrawerToBody();

    if (window.theme && (window.theme.YouTube || window.theme.VimeoPlayer)) {
      initializeVideoSections();
    } else {
      setTimeout(function() {
        if (window.theme && (window.theme.YouTube || window.theme.VimeoPlayer)) {
          initializeVideoSections();
        }
      }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  init();
})();
